<template>
  <!-- 评价成功 -->
  <div class="hireExpertSuccess">
     <mt-header title="支付成功">
      <mt-button slot="right" @click="finish()">完成</mt-button>
    </mt-header>
    <div class="content">
      <h1><icon name='check-circle'></icon>支付成功</h1>
      <!-- <p>您的项目【<span @click="toDetail()">{{projectTitle}}</span>】已完成担保金支付，我们将通过系统消息通知您雇佣的专家，该项目已担保。您可以通知专家开始工作。</p> -->
      <p>您的项目已将资金托管到平台，我们将通知您雇佣的专家该项目已担保，您可以和专家沟通工作进度。</p>
      <div class="info">
        <div class="portrait"><img :src="httpUrl+supplier.photo"></div>
        <div class="wrap">
          <div class="lineOne">
            <span>{{supplier.account.name}}</span><icon name="mars" v-if="supplier.sex == 1"></icon><icon name="venus" v-else></icon><span>{{supplier.position}}</span>
          </div>
          <div class="lineTwo">
            <span>{{supplier.cityName}}</span><span>{{supplier.enterTypeName}}</span><span>{{supplier.experienceName}}</span><span>{{supplier.salary}}元/天</span><span>{{supplier.workNum}}单</span>
          </div>
        </div>
        <div v-if="supplier.positionTypeName!=null" class="labels">
          <span v-for='(skillsList,index) in supplier.positionTypeName.split(",")' :key="index">{{skillsList}}</span>
        </div>
        <div class="starWrap">
            <div class="stars" v-if="project.star==5">
              <icon name='star'></icon><icon name='star'></icon><icon name='star'></icon><icon name='star'></icon><icon name='star'></icon><span>10.0</span>
            </div>
            <div class="stars" v-else-if="project.star==4.5">
              <icon name='star'></icon><icon name='star'></icon><icon name='star'></icon><icon name='star'></icon><icon name='star-half-o'></icon><span>9.0</span>
            </div>
            <div class="stars" v-else-if="project.star==4">
              <icon name='star'></icon><icon name='star'></icon><icon name='star'></icon><icon name='star'></icon><icon name='star-o'></icon><span>8.0</span>
            </div>
            <div class="stars" v-else-if="project.star==3.5">
              <icon name='star'></icon><icon name='star'></icon><icon name='star'></icon><icon name='star-half-o'></icon><icon name='star-o'></icon><span>7.0</span>
            </div>
            <div class="stars" v-else-if="project.star==3">
              <icon name='star'></icon><icon name='star'></icon><icon name='star'></icon><icon name='star-o'></icon><icon name='star-o'></icon><span>6.0</span>
            </div>
            <div class="stars" v-else-if="project.star==2.5">
              <icon name='star'></icon><icon name='star'></icon><icon name='star-half-o'></icon><icon name='star-o'></icon><icon name='star-o'></icon><span>5.0</span>
            </div>
            <div class="stars" v-else-if="project.star==2">
              <icon name='star'></icon><icon name='star'></icon><icon name='star-o'></icon><icon name='star-o'></icon><icon name='star-o'></icon><span>4.0</span>
            </div>
            <div class="stars" v-else-if="project.star==1.5">
              <icon name='star'></icon><icon name='star-half-o'></icon><icon name='star-o'></icon><icon name='star-o'></icon><icon name='star-o'></icon><span>3.0</span>
            </div>
            <div class="stars" v-else-if="project.star==1">
              <icon name='star'></icon><icon name='star-o'></icon><icon name='star-o'></icon><icon name='star-o'></icon><icon name='star-o'></icon><span>2.0</span>
            </div>
            <div class="stars" v-else-if="project.star==0.5">
              <icon name='star-half-o'></icon><icon name='star-o'></icon><icon name='star-o'></icon><icon name='star-o'></icon><icon name='star-o'></icon><span>1.0</span>
            </div>
            <div class="stars" v-else-if="project.star==0">
              <icon name='star-o'></icon><icon name='star-o'></icon><icon name='star-o'></icon><icon name='star-o'></icon><icon name='star-o'></icon><span>暂无无评价</span>
            </div>
          </div>
          <div class="proportion">
            <p>准时率<span>{{project.punctuality}}%</span></p>
            <p>完成质量<span>{{project.quality}}%</span></p>
            <p>满意度<span>{{project.satisfaction}}%</span></p>
          </div>
      </div>
    </div> 
    <div class="btns">
      <button type="button" @click="finish()">知道了</button>
    </div>
  </div>
</template>

<script>
import { Toast } from 'mint-ui'
export default {
  name: 'evaluateSuccess',
  data () {
    return {
      mars: true,
      evaluateStar: 3,
      projectId: '',
      supplierId: '',
      projectTitle: '',
      project: '',
      supplier: '',
      httpUrl: ''
    }
  },
  mounted () {
    this.STATE.commit('checkState', this.STATE.state)
    this.projectId = this.$route.query.projectId
    this.supplierId = window.localStorage.getItem('supplierId')
    this.getData()
    console.log(this.$route.query.projectId)
    console.log(window.localStorage.getItem('supplierId'))
  },
  methods: {
    goToJob: function () {
      this.$router.push({path: '/myJobs'})
    },
    getData: function () {
      let _this = this
      this.axios.get('url/paySuccessRecommender?projectId=' + this.projectId + '&supplierId=' + this.supplierId + '&accountId=' + this.STATE.state.loginId)
      .then(function (res) {
        console.log(res)
        _this.projectTitle = res.data.project[0].title
        _this.projectId = res.data.project[0].id
        _this.project = res.data.project[0]
        _this.supplier = res.data.supplier
        _this.httpUrl = res.data.httpUrl
      }).catch(function (response) {
        Toast({
          message: '网络异常',
          position: 'middle',
          duration: 1000
        })
      })
    },
    finish: function () {
      this.$router.push({path: '/myJobs'})
    },
    toDetail: function () {
      this.$router.push({name: 'myProjectDetail', params: { project: this.project, projectId: this.projectId }})
    }
  }
}
</script>

<style scoped>
.content{
  margin-top: 20%;
}
.content h1{
  font-size: 25px;
  font-weight: bold;
  text-align: center;
}
.content h1 .fa-icon{
  color: #108ee9;
  transform: scale(1.5);
  margin-right:10px;
}
.content p{
  font-size: 14px;
  text-indent: 24px;
  width: 80%;
  margin: 24px auto 0;
}
.content p span{
  color:#2f97eb;
  text-decoration: underline;
}
.info {
  width: 85%;
  border-radius:10px;
  -webkit-border-radius:10px;
  -moz-border-radius:10px;
  background-color: #e6f6fe;
  margin: 75px auto 0;
  text-align: center;
  padding-top:1px; 
}
.portrait{
  width: 75px;
  height: 75px;
  border-radius:50%;
  -webkit-border-radius:50%;
  -moz-border-radius:50%;
  background-color: #fff;
  margin: -37px auto 0;
}
.portrait img{
  width: 70px;
  height: 70px;
  border-radius:50%;
  -webkit-border-radius:50%;
  -moz-border-radius:50%;
  margin-top: 2.5px;
}
.wrap{
  margin-top:15px 0 11px;
  border-bottom:1px solid #e0e0e0;
}
.lineOne span,.lineOne .fa-icon{
  color: #108ee9;
}
.lineOne span:first-child{
  font-size: 14px;
}
.lineOne span:last-child{
  font-size: 12px;
  margin-left: 5px;
}
.lineOne .fa-icon{
  transform: scale(0.9);
  vertical-align: middle;
  margin: 0 5px;
}
.lineTwo{
  margin-top: 5px;
  margin-bottom:10px;
}
.lineTwo span{
  font-size: 12px;
  color: #727272;
  margin: 0 5px;
}
.labels{
  margin: 5px 0;
}
.labels span{
  margin: 5px;
  color: #108ee9;
  border: 1px solid #108ee9;
  border-radius:5px;
  -webkit-border-radius:5px;
  -moz-border-radius:5px;
  padding: 1px 5px;
  display: inline-block;
  font-size: 12px;
}
.stars .fa-icon{
  margin: 0 2.5px;
}
.stars span{
  color: #727272;
  display:inline-block;
  vertical-align: baseline;
  font-size: 18px;
  margin-left: 10px;
}
.proportion{
  overflow: hidden;
  display: inline-block;
  margin: 5px 0 20px;
}
.proportion p{
  float: left;
  text-indent: inherit;
  width: inherit;
  margin: inherit;
  font-size: 12px;
  color:#737373;
  margin: 0 5px;
}
.proportion p span{
  font-size: 14px;
  color: #000;
  margin-left: 2px;
  text-decoration: none;
}
.btns{
  margin-top: 20%;
  text-align: center;
  margin-bottom: 70px;
}
.btns button{
  width: 90%;
  font-size: 14px;
  color: #fff;
  background-color: #108ee9;
  height: 38px;
  border: none;
  outline:none;
  border-radius:20px;
  -webkit-border-radius:20px;
  -moz-border-radius:20px;
}
</style>


// WEBPACK FOOTER //
// hireExpertSuccess.vue?e38e16a8